import React from 'react';

interface PawIconProps {
  color?: string;
  width?: number;
  height?: number;
}

const PawIcon: React.FC<PawIconProps> = ({
  color = 'currentColor',
  width = 24,
  height = 24,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
    fill={color}
  >
    <path d="M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5c-14.3-42.9.3-86.2 32.6-96.8 32.4-10.6 70.2 15.6 84.4 58.5zm-114 177c-2.2 14.4 13.4 23.1 23.5 13.1l21.3-21.3c8.6-8.6 22.7-8.6 31.3 0l21.3 21.3c10.1 10.1 25.7 1.3 23.5-13.1-5.1-33.6-35.2-59.4-70.4-59.4s-65.3 25.8-70.5 59.4zm303-91.5c-14.3-42.9-52-69.1-84.4-58.5s-46.9 53.9-32.6 96.8c14.3 42.9 52 69.2 84.4 58.5s46.9-53.9 32.6-96.8zM146.3 312.8c-28.1 24.5-38.3 60.4-22.8 80.2 15.5 19.8 51.1 17.7 79.2-6.8 28.1-24.5 38.3-60.4 22.8-80.2-15.5-19.8-51.1-17.7-79.2 6.8zm219.4 0c-28.1-24.5-63.7-26.6-79.2-6.8-15.5 19.8-5.3 55.7 22.8 80.2 28.1 24.5 63.7 26.6 79.2 6.8 15.5-19.8 5.3-55.7-22.8-80.2z" />
  </svg>
);

export default PawIcon;
